import { z } from 'zod';

import { PrimaryKeySchema } from './utils';

export const WebsocketTopicSchema = z.enum([
  'resource_updated',
  'conversation_message_stream_updated',
  'ping',
  'subscription_confirmed',
  'error',
]);

export const ServerToClientWebsocketEventSchema = z.union([
  z.object({
    type: WebsocketTopicSchema.pipe(z.literal('ping')),
    data: z.null(),
  }),
  z.object({
    type: WebsocketTopicSchema.pipe(
      z.literal('conversation_message_stream_updated'),
    ),
    data: z.object({
      conversationId: PrimaryKeySchema,
      conversationMessageId: PrimaryKeySchema,
      message: z.string(),
      thoughts: z.array(
        z.object({
          text: z.string(),
          createdAt: z.string(),
        }),
      ),
    }),
  }),
  z.object({
    type: WebsocketTopicSchema.pipe(z.literal('resource_updated')),
    data: z.object({
      resourceType: z.string(),
      resourceId: PrimaryKeySchema,
    }),
  }),
  z.object({
    type: WebsocketTopicSchema.pipe(z.literal('subscription_confirmed')),
    data: z.object({
      topic: z.string(),
      options: z.record(z.unknown()),
    }),
  }),
  z.object({
    type: WebsocketTopicSchema.pipe(z.literal('error')),
    data: z.object({
      message: z.string(),
      topic: z.string().optional(),
    }),
  }),
]);

export type ServerToClientWebsocketEvent = z.infer<
  typeof ServerToClientWebsocketEventSchema
>;

export const ClientToServerWebsocketEventSchema = z.union([
  z.object({
    type: z.literal('subscribe'),
    data: z.union([
      z.object({
        topic: WebsocketTopicSchema.pipe(z.literal('ping')),
        options: z.object({}),
      }),
      z.object({
        topic: WebsocketTopicSchema.pipe(
          z.literal('conversation_message_stream_updated'),
        ),
        options: z.object({
          conversationId: PrimaryKeySchema,
        }),
      }),
      z.object({
        topic: WebsocketTopicSchema.pipe(z.literal('resource_updated')),
        options: z.object({
          resourceType: z.string(),
          resourceId: PrimaryKeySchema,
        }),
      }),
    ]),
  }),
  z.object({
    type: z.literal('unsubscribe'),
    data: z.union([
      z.object({
        topic: WebsocketTopicSchema.pipe(z.literal('ping')),
        options: z.object({}),
      }),
      z.object({
        topic: WebsocketTopicSchema.pipe(
          z.literal('conversation_message_stream_updated'),
        ),
        options: z.object({
          conversationId: PrimaryKeySchema,
        }),
      }),
      z.object({
        topic: WebsocketTopicSchema.pipe(z.literal('resource_updated')),
        options: z.object({
          resourceType: z.string(),
          resourceId: PrimaryKeySchema,
        }),
      }),
    ]),
  }),
]);

export type ClientToServerWebsocketEvent = z.infer<
  typeof ClientToServerWebsocketEventSchema
>;
